import type { WebcastContent } from '../generated/graphql-viewer';

// --- Manager ---

type HasTypename = { __typename?: string };

// Generic factory that narrows to the query-specific type (e.g. the type generated from the fragment),
// not the base schema type. This lets us remove fields from a fragment without causing type errors —
// the base schema type always includes every field, but query-specific types only include queried fields.
const findPolicy =
  <Name extends string>(name: Name) =>
  <T extends HasTypename>(policies: T[] = []) =>
    policies.find((policy): policy is Extract<T, { __typename?: Name }> => policy.__typename === name);

export const findAccessCodePolicy = findPolicy('AccessCodePolicy');
export const findSingleSignOnPolicy = findPolicy('SingleSignOnPolicy');
export const findReferrerProtectionPolicy = findPolicy('ReferrerProtectionPolicy');
export const findEmailRegistrationPolicy = findPolicy('EmailRegistrationPolicy');
export const findEmailWhitelistPolicy = findPolicy('EmailWhitelistPolicy');
export const findTokenProtectionPolicy = findPolicy('TokenProtectionPolicy');
export const findIpRangePolicy = findPolicy('IpRangePolicy');

// --- Viewer ---

export const findEventTitle = (
  contents?: WebcastContent[],
  selectedLanguageCode?: string,
  primaryLanguageCode?: string
) =>
  contents?.find((content) => content.language === selectedLanguageCode)?.title ||
  contents?.find((content) => content.language === primaryLanguageCode)?.title ||
  contents?.[0]?.title ||
  '';
